export const questionsHTML = {
  English: [
    {
      question: "Which tag defines the title of the page?",
      answers: [
        { answer: "<head>", correct: false, id: 1 },
        { answer: "<title>", correct: false, id: 2 },
        { answer: "<body>", correct: false, id: 3 },
        { answer: "<h1>", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which tag is used to create a hyperlink?",
      answers: [
        { answer: "<a>", correct: true, id: 1 },
        { answer: "<link>", correct: false, id: 2 },
        { answer: "<nav>", correct: false, id: 3 },
        { answer: "<href>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which attribute defines the text content for the <meta> tag?",
      answers: [
        { answer: "content", correct: true, id: 1 },
        { answer: "value", correct: false, id: 2 },
        { answer: "text", correct: false, id: 3 },
        { answer: "name", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Which tag is used to insert an image?",
      answers: [
        { answer: "<picture>", correct: false, id: 1 },
        { answer: "<img>", correct: true, id: 2 },
        { answer: "<media>", correct: false, id: 3 },
        { answer: "<graphic>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which tag should be used to highlight important text?",
      answers: [
        { answer: "<highlight>", correct: false, id: 1 },
        { answer: "<mark>", correct: true, id: 2 },
        { answer: "<important>", correct: false, id: 3 },
        { answer: "<strong>", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Which tag is used to define the header of a table?",
      answers: [
        { answer: "<th>", correct: true, id: 1 },
        { answer: "<thead>", correct: false, id: 2 },
        { answer: "<caption>", correct: false, id: 3 },
        { answer: "<hTable>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "What is the role of the <meta> tag in HTML?",
      answers: [
        { answer: "Text formatting", correct: false, id: 1 },
        { answer: "Creating hyperlinks", correct: false, id: 2 },
        { answer: "Providing metadata", correct: true, id: 3 },
        { answer: "Displaying images", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "What is the 'alt' attribute used for in the <img> tag?",
      answers: [
        { answer: "To change the size", correct: false, id: 1 },
        { answer: "For animation", correct: false, id: 2 },
        { answer: "Alternative text", correct: true, id: 3 },
        { answer: "To change the color", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Which tag is used to insert video?",
      answers: [
        { answer: "<media>", correct: false, id: 1 },
        { answer: "<img>", correct: false, id: 2 },
        { answer: "<video>", correct: true, id: 3 },
        { answer: "<audio>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Which tag allows creating an independent section or block that has semantic meaning?",
      answers: [
        { answer: "<block>", correct: false, id: 1 },
        { answer: "<div>", correct: false, id: 2 },
        { answer: "<section>", correct: true, id: 3 },
        { answer: "<area>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Which tag defines a list without numbering?",
      answers: [
        { answer: "<ol>", correct: false, id: 1 },
        { answer: "<ul>", correct: true, id: 2 },
        { answer: "<li>", correct: false, id: 3 },
        { answer: "<dl>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "What is the <link> tag used for?",
      answers: [
        { answer: "Loading images", correct: false, id: 1 },
        { answer: "Creating hyperlinks", correct: false, id: 2 },
        { answer: "Connecting CSS styles", correct: true, id: 3 },
        { answer: "Inserting audio content", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Which tag is used to create a form?",
      answers: [
        { answer: "<div>", correct: false, id: 1 },
        { answer: "<body>", correct: false, id: 2 },
        { answer: "<form>", correct: true, id: 3 },
        { answer: "<p>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Where is the correct HTML comment indicated?",
      answers: [
        { answer: "// This is a comment", correct: false, id: 1 },
        { answer: "/* This is a comment */", correct: false, id: 2 },
        { answer: "<!-- This is a comment -->", correct: true, id: 3 },
        { answer: "This is a comment", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which tag defines a text paragraph?",
      answers: [
        { answer: "<text>", correct: false, id: 1 },
        { answer: "<div>", correct: false, id: 2 },
        { answer: "<string>", correct: false, id: 3 },
        { answer: "<p>", correct: true, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Which tag creates a horizontal line?",
      answers: [
        { answer: "<line>", correct: false, id: 1 },
        { answer: "<hr>", correct: true, id: 2 },
        { answer: "<divide>", correct: false, id: 3 },
        { answer: "<split>", correct: false, id: 4 },
      ],
      score: 2,
    },
  ],
  Ukrainian: [
    {
      question: "Яким тегом визначається заголовок сторінки?",
      answers: [
        { answer: "<head>", correct: false, id: 1 },
        { answer: "<title>", correct: false, id: 2 },
        { answer: "<body>", correct: false, id: 3 },
        { answer: "<h1>", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який тег використовується для створення гіперпосилання?",
      answers: [
        { answer: "<a>", correct: true, id: 1 },
        { answer: "<link>", correct: false, id: 2 },
        { answer: "<nav>", correct: false, id: 3 },
        { answer: "<href>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який атрибут визначає текстовий контент для тега <meta>?",
      answers: [
        { answer: "content", correct: true, id: 1 },
        { answer: "value", correct: false, id: 2 },
        { answer: "text", correct: false, id: 3 },
        { answer: "name", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Який тег використовується для вставки зображення?",
      answers: [
        { answer: "<picture>", correct: false, id: 1 },
        { answer: "<img>", correct: true, id: 2 },
        { answer: "<media>", correct: false, id: 3 },
        { answer: "<graphic>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який тег слід використовувати для виділення важливого тексту?",
      answers: [
        { answer: "<highlight>", correct: false, id: 1 },
        { answer: "<mark>", correct: true, id: 2 },
        { answer: "<important>", correct: false, id: 3 },
        { answer: "<strong>", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Який тег використовується для задання заголовка таблиці?",
      answers: [
        { answer: "<th>", correct: true, id: 1 },
        { answer: "<thead>", correct: false, id: 2 },
        { answer: "<caption>", correct: false, id: 3 },
        { answer: "<hTable>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Яка роль тега <meta> в HTML?",
      answers: [
        { answer: "Форматування тексту", correct: false, id: 1 },
        { answer: "Створення гіперпосилань", correct: false, id: 2 },
        { answer: "Надання метаданих", correct: true, id: 3 },
        { answer: "Відображення зображень", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Для чого використовується атрибут 'alt' в тезі <img>?",
      answers: [
        { answer: "Для зміни розміру", correct: false, id: 1 },
        { answer: "Для анімації", correct: false, id: 2 },
        { answer: "Альтернативний текст", correct: true, id: 3 },
        { answer: "Для зміни кольору", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Який тег використовується для вставки відео?",
      answers: [
        { answer: "<media>", correct: false, id: 1 },
        { answer: "<img>", correct: false, id: 2 },
        { answer: "<video>", correct: true, id: 3 },
        { answer: "<audio>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Який тег дозволяє створити незалежний розділ або блок, що має семантичне значення?",
      answers: [
        { answer: "<block>", correct: false, id: 1 },
        { answer: "<div>", correct: false, id: 2 },
        { answer: "<section>", correct: true, id: 3 },
        { answer: "<area>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Яким тегом визначається список без нумерації?",
      answers: [
        { answer: "<ol>", correct: false, id: 1 },
        { answer: "<ul>", correct: true, id: 2 },
        { answer: "<li>", correct: false, id: 3 },
        { answer: "<dl>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Для чого використовується тег <link>?",
      answers: [
        { answer: "Завантаження зображень", correct: false, id: 1 },
        { answer: "Створення гіперпосилань", correct: false, id: 2 },
        { answer: "Підключення стилів CSS", correct: true, id: 3 },
        { answer: "Вставка аудіоконтенту", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Який тег використовується для створення форми?",
      answers: [
        { answer: "<div>", correct: false, id: 1 },
        { answer: "<body>", correct: false, id: 2 },
        { answer: "<form>", correct: true, id: 3 },
        { answer: "<p>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Де правильно вказано коментар в HTML?",
      answers: [
        { answer: "// Це коментар", correct: false, id: 1 },
        { answer: "/* Це коментар */", correct: false, id: 2 },
        { answer: "<!-- Це коментар -->", correct: true, id: 3 },
        { answer: "` Це коментар `", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яким тегом визначається текстовий абзац?",
      answers: [
        { answer: "<text>", correct: false, id: 1 },
        { answer: "<div>", correct: false, id: 2 },
        { answer: "<string>", correct: false, id: 3 },
        { answer: "<p>", correct: true, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Який тег створює горизонтальну лінію?",
      answers: [
        { answer: "<line>", correct: false, id: 1 },
        { answer: "<hr>", correct: true, id: 2 },
        { answer: "<divide>", correct: false, id: 3 },
        { answer: "<split>", correct: false, id: 4 },
      ],
      score: 2,
    },
  ],
  Polish: [
    {
      question: "Który tag definiuje tytuł strony?",
      answers: [
        { answer: "<head>", correct: false, id: 1 },
        { answer: "<title>", correct: false, id: 2 },
        { answer: "<body>", correct: false, id: 3 },
        { answer: "<h1>", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Który tag jest używany do tworzenia hiperłącza?",
      answers: [
        { answer: "<a>", correct: true, id: 1 },
        { answer: "<link>", correct: false, id: 2 },
        { answer: "<nav>", correct: false, id: 3 },
        { answer: "<href>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Który atrybut definiuje zawartość tekstową tagu <meta>?",
      answers: [
        { answer: "content", correct: true, id: 1 },
        { answer: "value", correct: false, id: 2 },
        { answer: "text", correct: false, id: 3 },
        { answer: "name", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Który tag służy do wstawiania obrazu?",
      answers: [
        { answer: "<picture>", correct: false, id: 1 },
        { answer: "<img>", correct: true, id: 2 },
        { answer: "<media>", correct: false, id: 3 },
        { answer: "<graphic>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Którego tagu użyć do wyróżnienia ważnego tekstu?",
      answers: [
        { answer: "<highlight>", correct: false, id: 1 },
        { answer: "<mark>", correct: true, id: 2 },
        { answer: "<important>", correct: false, id: 3 },
        { answer: "<strong>", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Który znacznik służy do zdefiniowania nagłówka tabeli?",
      answers: [
        { answer: "<th>", correct: true, id: 1 },
        { answer: "<thead>", correct: false, id: 2 },
        { answer: "<caption>", correct: false, id: 3 },
        { answer: "<hTable>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Jaka jest rola tagu <meta> w HTML?",
      answers: [
        { answer: "Formatowanie tekstu", correct: false, id: 1 },
        { answer: "Tworzenie hiperłączy", correct: false, id: 2 },
        { answer: "Podawanie metadanych", correct: true, id: 3 },
        { answer: "Wyświetlanie obrazów", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Do czego służy atrybut 'alt' w tagu <img>?",
      answers: [
        { answer: "Aby zmienić rozmiar", correct: false, id: 1 },
        { answer: "Dla animacji", correct: false, id: 2 },
        { answer: "Tekst alternatywny", correct: true, id: 3 },
        { answer: "Aby zmienić kolor", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Który tag służy do wstawiania wideo?",
      answers: [
        { answer: "<media>", correct: false, id: 1 },
        { answer: "<img>", correct: false, id: 2 },
        { answer: "<video>", correct: true, id: 3 },
        { answer: "<audio>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Który tag umożliwia utworzenie niezależnej sekcji lub bloku o znaczeniu semantycznym?",
      answers: [
        { answer: "<block>", correct: false, id: 1 },
        { answer: "<div>", correct: false, id: 2 },
        { answer: "<section>", correct: true, id: 3 },
        { answer: "<area>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Który znacznik definiuje listę bez numeracji?",
      answers: [
        { answer: "<ol>", correct: false, id: 1 },
        { answer: "<ul>", correct: true, id: 2 },
        { answer: "<li>", correct: false, id: 3 },
        { answer: "<dl>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Do czego służy tag <link>?",
      answers: [
        { answer: "Ładowanie obrazów", correct: false, id: 1 },
        { answer: "Tworzenie hiperłączys", correct: false, id: 2 },
        { answer: "Łączenie stylów CSS", correct: true, id: 3 },
        { answer: "Wstawianie treści audio", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Który tag służy do tworzenia formularza?",
      answers: [
        { answer: "<div>", correct: false, id: 1 },
        { answer: "<body>", correct: false, id: 2 },
        { answer: "<form>", correct: true, id: 3 },
        { answer: "<p>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Gdzie wskazany jest prawidłowy komentarz HTML?",
      answers: [
        { answer: "// To jest komentarz", correct: false, id: 1 },
        { answer: "/* To jest komentarz */", correct: false, id: 2 },
        { answer: "<!-- To jest komentarz -->", correct: true, id: 3 },
        { answer: "To jest komentarz", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Który znacznik definiuje akapit tekstowy?",
      answers: [
        { answer: "<text>", correct: false, id: 1 },
        { answer: "<div>", correct: false, id: 2 },
        { answer: "<string>", correct: false, id: 3 },
        { answer: "<p>", correct: true, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Który znacznik tworzy linię poziomą?",
      answers: [
        { answer: "<line>", correct: false, id: 1 },
        { answer: "<hr>", correct: true, id: 2 },
        { answer: "<divide>", correct: false, id: 3 },
        { answer: "<split>", correct: false, id: 4 },
      ],
      score: 2,
    },
  ],
  German: [
    {
      question: "Welches Tag definiert den Titel der Seite?",
      answers: [
        { answer: "<head>", correct: false, id: 1 },
        { answer: "<title>", correct: false, id: 2 },
        { answer: "<body>", correct: false, id: 3 },
        { answer: "<h1>", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welches Tag wird zum Erstellen eines Hyperlinks verwendet?",
      answers: [
        { answer: "<a>", correct: true, id: 1 },
        { answer: "<link>", correct: false, id: 2 },
        { answer: "<nav>", correct: false, id: 3 },
        { answer: "<href>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welches Attribut definiert den Textinhalt für das <meta>-Tag?",
      answers: [
        { answer: "content", correct: true, id: 1 },
        { answer: "value", correct: false, id: 2 },
        { answer: "text", correct: false, id: 3 },
        { answer: "name", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Mit welchem Tag wird ein Bild eingefügt?",
      answers: [
        { answer: "<picture>", correct: false, id: 1 },
        { answer: "<img>", correct: true, id: 2 },
        { answer: "<media>", correct: false, id: 3 },
        { answer: "<graphic>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Welches Tag sollte verwendet werden, um wichtigen Text hervorzuheben?",
      answers: [
        { answer: "<highlight>", correct: false, id: 1 },
        { answer: "<mark>", correct: true, id: 2 },
        { answer: "<important>", correct: false, id: 3 },
        { answer: "<strong>", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question:
        "Welches Tag wird verwendet, um den Kopf einer Tabelle zu definieren?",
      answers: [
        { answer: "<th>", correct: true, id: 1 },
        { answer: "<thead>", correct: false, id: 2 },
        { answer: "<caption>", correct: false, id: 3 },
        { answer: "<hTable>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Welche Rolle spielt das <meta>-Tag in HTML?",
      answers: [
        { answer: "Textformatierung", correct: false, id: 1 },
        { answer: "Hyperlinks erstellen", correct: false, id: 2 },
        { answer: "Metadaten bereitstellen", correct: true, id: 3 },
        { answer: "Bilder anzeigen", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Wofür wird das 'alt'-Attribut im <img>-Tag verwendet?",
      answers: [
        { answer: "Um die Größe zu ändern", correct: false, id: 1 },
        { answer: "Für animation", correct: false, id: 2 },
        { answer: "Alternativer text", correct: true, id: 3 },
        { answer: "Um die farbe zu ändern", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Welches Tag wird verwendet, um ein Video einzufügen?",
      answers: [
        { answer: "<media>", correct: false, id: 1 },
        { answer: "<img>", correct: false, id: 2 },
        { answer: "<video>", correct: true, id: 3 },
        { answer: "<audio>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Welches Tag ermöglicht das Erstellen eines unabhängigen Abschnitts oder Blocks mit semantischer Bedeutung?",
      answers: [
        { answer: "<block>", correct: false, id: 1 },
        { answer: "<div>", correct: false, id: 2 },
        { answer: "<section>", correct: true, id: 3 },
        { answer: "<area>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Welches Tag definiert eine Liste ohne Nummerierung?",
      answers: [
        { answer: "<ol>", correct: false, id: 1 },
        { answer: "<ul>", correct: true, id: 2 },
        { answer: "<li>", correct: false, id: 3 },
        { answer: "<dl>", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wofür wird das <link>-Tag verwendet?",
      answers: [
        { answer: "Bilder laden", correct: false, id: 1 },
        { answer: "Hyperlinks erstellen", correct: false, id: 2 },
        { answer: "CSS-stile verbinden", correct: true, id: 3 },
        { answer: "Audio-inhalte einfügen", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Welches Tag wird verwendet, um ein Formular zu erstellen?",
      answers: [
        { answer: "<div>", correct: false, id: 1 },
        { answer: "<body>", correct: false, id: 2 },
        { answer: "<form>", correct: true, id: 3 },
        { answer: "<p>", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Wo ist der korrekte HTML-Kommentar angegeben?",
      answers: [
        { answer: "// Dies ist ein kommentar", correct: false, id: 1 },
        { answer: "/* Dies ist ein kommentar */", correct: false, id: 2 },
        { answer: "<!-- Dies ist ein kommentar -->", correct: true, id: 3 },
        { answer: "Dies ist ein kommentar", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welcher Tag definiert einen Textabsatz?",
      answers: [
        { answer: "<text>", correct: false, id: 1 },
        { answer: "<div>", correct: false, id: 2 },
        { answer: "<string>", correct: false, id: 3 },
        { answer: "<p>", correct: true, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Welcher Tag hat eine horizontale Linie erstellt?",
      answers: [
        { answer: "<line>", correct: false, id: 1 },
        { answer: "<hr>", correct: true, id: 2 },
        { answer: "<divide>", correct: false, id: 3 },
        { answer: "<split>", correct: false, id: 4 },
      ],
      score: 2,
    },
  ],
};
